import { useEffect, useMemo, useState } from "react";
import { Stack } from "@mui/material";
import { LegendComponent } from "../../../../../../common/components/legend_component";
import { LegendIcon } from "../../../../../../common/components/legend_icon";
import { LegendItemComponent } from "../../../../../../common/components/legend_item_component";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GenerateTreinamentosColumnsDefinition } from "../columns/generate_treinamento";

import PrimaryButton from "../../../../../../common/components/primary_button";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { FuncionarioTreinamento } from "../../../../../rh/domain/models/funcionario_treinamento";


type Props = {
  loading: boolean,
  treinamentosLista: FuncionarioTreinamento[],
  onCadastrar: (idTreinamento: number | null, openState: boolean) => void,
  onAvaliar: (idTreinamento: number | null, openState: boolean) => void,
  onAvaliarLote: (idTreinamento: number[], openState: boolean) => void,
  onExportar: (idTreinamento: number) => void,
  onEditar: (idTreinamento: number | null, openState: boolean) => void,
  onDeletar: (idTreinamento: number | null, openState: boolean) => void,
  onDeletarLote: (idTreinamento: number[], openState: boolean) => void,
};

export const TabTreinamentosContent = ({
  loading,
  treinamentosLista,
  onCadastrar,
  onAvaliar,
  onAvaliarLote,
  onExportar,
  onEditar,
  onDeletar,
  onDeletarLote,
}: Props) => {
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

  const treinamentosColumnsDefinition = useMemo(() => {
    return GenerateTreinamentosColumnsDefinition({
      onAvaliarTreinamento: (id) => onAvaliar(id, true),
      onExportar: (id) => onExportar(id),
      onEditar: (id) => onEditar(id, true),
      onDeletar: (id) => onDeletar(id, true),
    });
  }, [onAvaliar, onExportar, onEditar, onDeletar]);

  useEffect(() => {
    setRowSelectionModel({ type: 'include', ids: new Set() });
  }, [treinamentosLista]);

  return (
    <>
      <>
        <div className="div flex mt-8 justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-xl font-medium text-black dark:text-white">
              Treinamentos
            </h1>
          </div>

          <div className="flex w-[35rem] w-full justify-end flex gap-2">
            <PrimaryButton
              className="whitespace-nowrap"
              sx={{ paddingX: 3 }}
              onClick={() => onCadastrar(null, true)}>
              Treinamento realizado
            </PrimaryButton>

            <PrimaryButton
              buttonColor='yellow'
              className="whitespace-nowrap"
              onClick={() => onAvaliarLote([...rowSelectionModel.ids.values()].filter((x) => typeof x === 'number') as number[], true)}
              sx={{ paddingX: 3 }}>
              Avaliar Selecionados
            </PrimaryButton>

            {/* <PrimaryButton
              buttonColor='red'
              className="whitespace-nowrap"
              onClick={() => onDeletarLote([...rowSelectionModel.ids.values()].filter((x) => typeof x === 'number') as number[], true)}
              sx={{ paddingX: 3 }}>
              Excluir Selecionados
            </PrimaryButton> */}
          </div>
        </div>
      </>

      <Stack spacing={0} className="mt-4">
        <div className="w-full flex flex-row justify-between items-end my-4">
          <LegendComponent>
            <LegendItemComponent
              icon={<LegendIcon color='red' title='A' />}
              label='Avaliação em Atraso' />

            <LegendItemComponent
              icon={<LegendIcon color='blue' title='D' />}
              label='Dentro do Prazo' />

            <LegendItemComponent
              icon={<LegendIcon color='yellow' title='N' />}
              label='Não Realizado' />

            <LegendItemComponent
              icon={<LegendIcon color='green' title='A' />}
              label='Avaliados' />
          </LegendComponent>
        </div>

        <StyledDataGrid
          tableName="tab_treinamentos_content"
          disableColumnMenu={false}
          disableRowSelectionOnClick={true}
          checkboxSelection={true}
          getRowId={(row: FuncionarioTreinamento) => row.idFuncionarioTreinamento}
          columns={treinamentosColumnsDefinition}
          loading={loading}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={(gridSelectionModel) => setRowSelectionModel(gridSelectionModel)}
          rows={treinamentosLista}
          rowCount={treinamentosLista.length}
          pageSizeOptions={[50]}
          paginationMode="server"
          pinnedColumns={{
            right: ['idFuncionarioTreinamento'],
          }}
        />

      </Stack>
    </>
  );
}